import { IOrganisationDetails } from '../services/organisation/organisation.model';

/** Single source of truth for whether FLAG-related UI and client flows should be available. */
export function getFlagEmissionsEnabled(organisation?: IOrganisationDetails | null): boolean {
  return organisation?.isFlagEnabled === true;
}
